import React, { ReactNode } from 'react';

import Button from '../../library/button/button';
import Image from '../../library/image/image';
import Typography from '../../library/typography/typography';

import './easy-pay-option.scss';

interface EasyPayOptionProps {
  className?: string;
  imageAlt: string;
  imageUrl: string;
  linkText: string;
  message: ReactNode;
  onClick: () => void;
  showLinkAsCTA?: boolean;
  title: string;
}

function EasyPayOption(props: EasyPayOptionProps) {
  const {
    className = '',
    imageAlt,
    imageUrl,
    linkText,
    message,
    onClick,
    showLinkAsCTA,
    title
  } = props;

  return (
    <aside className={`easy-pay-option ${className}`} styleName="container">
      <Image alt={imageAlt} loading="lazy" src={imageUrl} styleName="image" />
      <div
        className="easy-pay-option__description-container"
        styleName={`description-container ${
          showLinkAsCTA ? 'description-container-cta' : ''
        }`}
      >
        <div className="easy-pay-option__description" styleName="description">
          <Typography styleName="title" tag="p" variant="H6">
            {title}
          </Typography>
          <Typography styleName="message" tag="p" weight="heavy">
            {message}
          </Typography>
        </div>
        {!showLinkAsCTA && (
          <Button
            className="easy-pay-option__link"
            onClick={onClick}
            size="regular"
            styleName="link"
          >
            {linkText}
          </Button>
        )}
      </div>
      {showLinkAsCTA && (
        <Button
          isSecondary={showLinkAsCTA}
          onClick={onClick}
          size="regular"
          styleName="cta"
        >
          {linkText}
        </Button>
      )}
    </aside>
  );
}

export default EasyPayOption;
